import styled from "styled-components";
export const ViewOrgProjectsSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;
  display: flex;
  gap: 2em;
  flex-direction: column;
  .create-member {
    align-self: flex-end;
  }
  .project-details {
    width: 80vw;
    margin: 0 auto;
    display: flex;
    gap: 3rem;
    flex-direction: column;
    justify-content: space-around;
  }
  .member-container {
    display: flex;
    flex-wrap: wrap;
    gap: 3rem;
  }
  .create-delete-project {
    display: flex;
    justify-content: space-between;
  }
`;
